import React from "react";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import Button from "components/CustomButtons/Button";

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(3),
    borderRadius: "6px",
  },
  description: {
    color: "#555",
    marginBottom: theme.spacing(3),
    maxWidth: "680px",
  },
  actionRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
  buttonProgress: {
    color: "#fff",
    marginRight: theme.spacing(1),
  },
  confirmationActions: {
    padding: theme.spacing(1, 3, 2),
  },
}));

function RunNachaCard({ loading, onRun }) {
  const classes = useStyles();
  const [confirmOpen, setConfirmOpen] = React.useState(false);

  const handleOpenConfirm = () => {
    if (!loading) {
      setConfirmOpen(true);
    }
  };

  const handleCloseConfirm = () => {
    if (!loading) {
      setConfirmOpen(false);
    }
  };

  const handleConfirm = () => {
    setConfirmOpen(false);
    onRun();
  };

  return (
    <>
      <Paper className={classes.card}>
        <Typography variant="h5" gutterBottom>
          NACHA Processing
        </Typography>
        <Typography className={classes.description} variant="body1">
          Generate NACHA files for all eligible transaction headers.
        </Typography>
        <div className={classes.actionRow}>
          <Button
            // color="primary"
            disabled={loading}
            onClick={handleOpenConfirm}
          >
            {loading && (
              <CircularProgress
                className={classes.buttonProgress}
                size={16}
                thickness={5}
              />
            )}
            <PlayArrowIcon />
            {loading ? "Generating NACHA Files..." : "Generate NACHA Files"}
          </Button>
        </div>
      </Paper>
      <Dialog
        open={confirmOpen}
        onClose={handleCloseConfirm}
        aria-labelledby="nacha-processing-confirm-title"
        aria-describedby="nacha-processing-confirm-description"
      >
        <DialogTitle id="nacha-processing-confirm-title">
          Confirm NACHA Processing
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="nacha-processing-confirm-description">
            This will generate NACHA files for all eligible transaction headers.
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.confirmationActions}>
          <Button cancel disabled={loading} onClick={handleCloseConfirm}>
            Cancel
          </Button>
          <Button disabled={loading} onClick={handleConfirm}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

RunNachaCard.propTypes = {
  loading: PropTypes.bool,
  onRun: PropTypes.func.isRequired,
};

RunNachaCard.defaultProps = {
  loading: false,
};

export default RunNachaCard;
